import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';

const stats = [
  { value: 150, suffix: '+', label: 'Projecten Afgerond' },
  { value: 10, suffix: '+', label: 'Vakspecialisten' },
  { value: 5, suffix: '+', label: 'Jaar Ervaring' },
  { value: 99, suffix: '%', label: 'Klanttevredenheid' },
];

function AnimatedCounter({ target, suffix, inView }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!inView) return;
    let start = 0;
    const duration = 2000;
    const increment = target / (duration / 16);
    const timer = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(timer);
      } else {
        setCount(Math.floor(start));
      }
    }, 16);
    return () => clearInterval(timer);
  }, [inView, target]);

  return (
    <span className="text-4xl md:text-5xl font-bold text-white">
      {count}{suffix}
    </span>
  );
}

export default function Stats() {
  const [ref, inView] = useInView({ threshold: 0.3 });

  return (
    <section ref={ref} className="py-20 px-6 md:px-12 lg:px-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-ferry-crimson/5 via-transparent to-ferry-crimson/5" />

      <div className="max-w-7xl mx-auto relative">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="text-center"
            >
              <AnimatedCounter target={stat.value} suffix={stat.suffix} inView={inView} />
              <p className="text-ferry-gray-text mt-2 text-sm md:text-base">{stat.label}</p>
              <div className="w-8 h-0.5 bg-ferry-crimson/40 mx-auto mt-4" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
